/** Estados de seguimiento PQRS en administración. */
export const PQRS_STATUSES = [
  { value: 'pendiente', label: 'Pendiente', color: 'amber' },
  { value: 'en_proceso', label: 'En proceso', color: 'blue' },
  { value: 'respondido', label: 'Respondido', color: 'green' },
  { value: 'cerrado', label: 'Cerrado', color: 'slate' },
];

export function getPqrsStatusLabel(value) {
  return PQRS_STATUSES.find((s) => s.value === value)?.label ?? value;
}

export function getPqrsStatusClasses(color) {
  const map = {
    amber: 'bg-amber-50 text-amber-800 ring-amber-200',
    blue: 'bg-sky-50 text-sky-800 ring-sky-200',
    green: 'bg-emerald-50 text-emerald-800 ring-emerald-200',
    slate: 'bg-slate-100 text-slate-600 ring-slate-200',
  };
  return map[color] ?? map.slate;
}
